import { CSSProperties } from 'react';

import './style.css';

export interface CardLayoutProps {
  style?: CSSProperties;
  className?: string;
}

interface CardProps extends CardLayoutProps {
  children?: React.ReactNode
}

const Card: React.FC<CardProps> = ({
  style,
  children,
  className,
}) => {
  return (
    <div
      className={`bg-white card-shadow rounded ${className ?? ''}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
